<mat-selection-list #matSelection role="list" class="list-jornadas" (selectionChange)="getSelected($event)"
  [compareWith]="compareObjects" [formControl]="control">
  <mat-list-option #matOptions *ngFor="let item of result" [value]="item">
    {{ item.IdJornada + ' - ' + item.Njornada }}
  </mat-list-option>
</mat-selection-list>